<script>
export default {
    name: "PostedBillDetails",

    data() {

        return {
            patient: {},
            billItems: [],
        };
    },

    computed: {

      grandTotal() {
  
        if(!this.billItems.length) return 0;

        const billItemsFiltered = this.billItems.filter(billI => billI.grandTotal);

        if(!billItemsFiltered.length) return 0;

        const billItems = billItemsFiltered.map(billI => parseFloat(billI.grandTotal));

        return billItems.reduce((gTotal, accTotal) => gTotal + accTotal);
      },
    },

    mounted() {

        Promise.allSettled([this.fetchPatient(), this.fetchBillDetails(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatient() {

            return this.$http.get(`PatientRegistration/GetSpecificPatient?PatientID=${this.$route.query.patientID}`).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchBillDetails() {

            return this.$http.get(`AccountsReports/GetPostedBillsPatientItems?BillNo=${this.$route.query.billNo}`).then(response => {
                this.billItems = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full my-2 text-center">
            <h5 class="font-bold text-base">Patient Bill</h5>
        </div>
        <div class="w-full flex flex-row text-base">
            <div class="flex-1">
                <h5 class="font-medium">{{ patient.names }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">IPFile No: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">OPFile No: {{ patient.opfileno}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-medium">MRN: {{ patient.patienT_ID }}</h5>
            </div>
        </div>
        <table class="table">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">Txn Date</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Description</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Price</th>
                    <th class="p-tiny">Grand Total</th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <tr v-for="(bill, idx) in billItems" :key="idx">
                    <td class="p-tiny">{{ bill.txnDate | dateFormat }}</td>
                    <td class="p-tiny">{{ bill.itemName }}</td>
                    <td class="p-tiny">{{ bill.description }}</td>
                    <td class="p-tiny">{{ bill.quantity }}</td>
                    <td class="p-tiny">{{ bill.charge | numberFormat }}</td>
                    <td class="p-tiny">{{ bill.grandTotal | numberFormat }}</td>
                </tr>
            </tbody>
            <tfoot>
              <tr>
                    <th colspan="4" class="p-tiny"></th>
                    <th class="p-tiny">Total</th>
                    <th class="p-tiny">{{ grandTotal | numberFormat }}</th>
                </tr>
            </tfoot>
         </table>
    </div>
</template>
